import React, { useEffect, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import {
  Card,
  CardContent,
  Chip,
  Grid,
  IconButton,
  Tooltip,
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import { InfoOutlined } from '@material-ui/icons';
import { useHistory } from 'react-router';
import { AppContainer } from '../../packages/AppContainer';
import InfoModal from '../../packages/AppModal/Info';
import { AppButton } from '../../packages/AppButton';
import { APP_CONSTANTS } from '../../constants';
import IOSSwitch from '../../packages/AppIOSSwitch';

const useStyles = makeStyles(() => ({
  root: {
    borderRadius: '20px',
    boxShadow: '0px 1px 4px rgba(0, 0, 0, 0.16)',
    backgroundColor: 'rgba(166, 224, 222, 1)',
  },
  infoIcon: {
    color: 'white',
  },
  infoButton: {
    padding: '0px',
    cursor: 'pointer',
  },
  chip: {
    backgroundColor: '#09bb9f',
    color: 'white',
    fontSize: '13px',
    '& .MuiChip-label': {
      overflow: 'unset',
    },
  },
  tooltip: {
    fontSize: '18px',
  },
}));
export default function Products() {
  const agencyList = useSelector((state) => state.Agency.agencyList);
  const userType = useSelector((state) => state.User.userType);
  const history = useHistory();
  const queryParams = new URLSearchParams(window.location.search);
  const classes = useStyles();
  const [isInfoDialogOpen, setIsInfoDialogOpen] = useState(false);
  const [productsList, setProductsList] = useState([]);

  const getProductsList = (user_type) => {
    const DEFAULT_PRODUCTS = [
      {
        productId: 'ENGAGE',
        productName: 'Engage',
        productTitle: 'Human Powered Live Chat Leads',
        productInfo:
          'Engage provides 24/7 real-time, human-powered live chat to convert website visitors into clients and caregivers.',
        productPrice: null,
        isProductActive: true,
        productActions: [
          {
            actionType: 'button',
            buttonText: 'Setup Complete',
            style: { backgroundColor: '#09bb9f', color: 'white' },
            isDisabled: false,
            onClick: () => {},
          },
        ],
      },
      {
        productId: 'SCHEDULE',
        productName: 'Schedule+',
        productTitle: 'Schedule Assessments and Interviews',
        productInfo:
          "Schedule+ provides real-time concierge scheduling. Our human chat agents book client consultations and caregiver interviews directly on your agency's calendar.",
        productPrice: '$199/Month',
        isProductActive: true,
        productActions: [
          {
            actionType: 'button',
            buttonText: 'Setup Product',
            isDisabled: false,
            style: { backgroundColor: '#09bb9f', color: 'white' },
            onClick: (productId) => {
              history.push(
                `${APP_CONSTANTS.APP_ROUTE_URLS.AGENCIES_PRODUCT_ACCESS}/${productId}`,
              );
            },
          },
        ],
      },
      // {
      //   productId: 'NURTURE',
      //   productName: 'Nurture',
      //   productTitle: 'AI + Human Follow Through',
      //   productInfo:
      //     'Follow leverages AI and human intelligence to ensure consistent follow-ups and increase response rates.',
      //   productPrice: '$199/Month',
      //   isProductActive: false,
      //   productActions: [],
      // },
      {
        productId: 'AGENT_Q',
        productName: 'Agent Q',
        productTitle: 'Branded QR Code App',
        productInfo:
          'Agent Q enables seamless customer interactions through QR codes, instantly connecting home care agencies with clients, caregivers and referral sources. Available for organizations with 50 or more offices.',
        productPrice: '$99/Month',
        isProductActive: false,
        productActions: [],
      },
      // {
      //   productId: 'ANSWER',
      //   productName: 'Answer',
      //   productTitle: 'AI + Human Call Center',
      //   productInfo:
      //     'Answer combines AI and human agents to provide efficient and high-quality call center support for businesses.',
      //   productPrice: null,
      //   isProductActive: false,
      //   productActions: [],
      // },
      // {
      //   productId: 'BOOST',
      //   productName: 'Boost',
      //   productTitle: 'Super Charge Client Leads',
      //   productInfo:
      //     'Boost helps businesses generate and manage client leads effectively, driving higher conversion rates and business growth.',
      //   productPrice: '$999/Month',
      //   isProductActive: false,
      //   productActions: [],
      // },
    ];
    const USER_SPECIFIC_PRODUCTS = {
      AGENCY_ADMIN_BASIC: [...DEFAULT_PRODUCTS],
      AGENCY_ADMIN: [...DEFAULT_PRODUCTS],
      BOOMERS_ADMIN: [...DEFAULT_PRODUCTS],
      DELEGATE: [...DEFAULT_PRODUCTS],
      DELEGATE_RW: [...DEFAULT_PRODUCTS],
      BOOMERS_ADMIN_AGENCY: [...DEFAULT_PRODUCTS],
      SUPER_ADMIN_2: [...DEFAULT_PRODUCTS],
    };
    return USER_SPECIFIC_PRODUCTS[user_type];
  };

  useEffect(() => {
    if (queryParams?.get('showInfoModal') && agencyList?.length) {
      setTimeout(() => {
        setIsInfoDialogOpen(true);
      }, 1000);
    }
  }, [agencyList]);

  useEffect(() => {
    if (userType) {
      const productList = getProductsList(userType);
      setProductsList(productList);
    }
  }, [userType]);

  return useMemo(
    () => (
      <>
        <AppContainer>
          <Grid
            container
            direction="row"
            justify="flex-start"
            alignItems="center"
            alignContent="center"
            spacing={2}
          >
            {productsList?.map((product) => (
              <Grid item xs={12} sm={12} md={6} lg={4} xl={4}>
                <Card className={classes.root} elevation={0} square>
                  <CardContent>
                    <Box
                      display="flex"
                      justifyContent="space-between"
                      alignItems="center"
                      alignContent="center"
                      height="30px"
                    >
                      <Box>
                        {!product?.isProductActive && (
                          <Chip
                            className={classes?.chip}
                            label="Coming Soon..."
                          />
                        )}
                      </Box>
                      <Tooltip
                        classes={{ tooltip: classes.tooltip }}
                        title={product?.productInfo}
                        arrow
                      >
                        <IconButton className={classes?.infoButton}>
                          <InfoOutlined className={classes?.infoIcon} />
                        </IconButton>
                      </Tooltip>
                    </Box>
                    <Box
                      color="black"
                      height="200px"
                      display="flex"
                      flexDirection="column"
                      justifyContent="center"
                      alignItems="center"
                      alignContent="center"
                    >
                      <Typography
                        gutterBottom
                        variant="h5"
                        component="h2"
                        color="inherit"
                      >
                        {product?.productName}
                      </Typography>
                      <Typography
                        gutterBottom
                        variant="h6"
                        component="h6"
                        color="inherit"
                      >
                        {product?.productTitle}
                      </Typography>

                      <Typography
                        gutterBottom
                        variant="h6"
                        component="h6"
                        color="inherit"
                        style={{ fontSize: '17px', marginBottom: '0px' }}
                      >
                        {product?.productPrice}
                      </Typography>
                      {product?.productActions?.map((action) => {
                        switch (action.actionType) {
                          case 'switch':
                            return (
                              <>
                                <IOSSwitch
                                  checked={action?.status}
                                  onChange={() => {
                                    action.onClick();
                                  }}
                                />
                              </>
                            );
                          case 'button':
                            return (
                              <AppButton
                                variant="contained"
                                color="primary"
                                disabled={action?.isDisabled}
                                label={action?.buttonText}
                                handleClick={() => {
                                  action.onClick(product?.productId);
                                }}
                                size="small"
                                style={{
                                  borderRadius: '5px',
                                  marginTop: '20px',
                                  ...action?.style,
                                }}
                              />
                            );
                          default:
                            return <></>;
                        }
                      })}
                    </Box>
                  </CardContent>
                </Card>
              </Grid>
            ))}
          </Grid>
        </AppContainer>

        <InfoModal
          title="Additional Products"
          isOpen={isInfoDialogOpen}
          onClose={() => {}}
        >
          You have successfully registered for AidQuest Human Powered Live Chat.
          You can now activate additional products by clicking on set-up for
          each product.
        </InfoModal>
      </>
    ),
    [isInfoDialogOpen, productsList],
  );
}
